import { confirmAlert } from "react-confirm-alert";
import Button from "../Button";
import { mediaMatch } from "../../utils";
import { getI18n } from "react-i18next";
import QRCode from "qrcode.react";
import "./index.css";
import React from "react";

function confirm(props) {
  const { title, content, onOk, confirmText = "确定" } = props;
  const isMdmax = mediaMatch.isMdmax;
  const is1Xl = mediaMatch.is1Xl;
  const t = getI18n().t; // 该函数没有返回render 无法使用hook，只能调用api
  const _title = title ? t(title) : t("提示");

  const PCDialog = ({ onClose }) => {
    return (
      <div
        className="rounded-[5px] z-50 fixed bg-white p-[30px] pt-[40px] pb-[20px]"
        style={{
          width: isMdmax ? "35%" : is1Xl ? "22%" : "33%",
          top: "20%",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        <div className="flex mb-[30px]">
          <div className="mr-[20px]">
            <i
              className="iconfont icon-warning-circle-fill"
              style={{ color: "#faad14", fontSize: 36 }}
            />
          </div>
          <div>
            {_title && (
              <div className="mb-[5px] flex justify-between items-center">
                <p className="text-[15px] text-[#666]">{_title}</p>
              </div>
            )}
            <div>
              {typeof content === "string" ? content : content({ onClose })}
            </div>
          </div>
        </div>
        <div className="text-right">
          <Button
            onClick={() => onClose()}
            className="rounded-[5px] border-[#ddd] border-[1px] py-[5px] px-[24px]"
          >
            {t("取消")}
          </Button>
          <Button
            onClick={() => {
              onOk(onClose);
            }}
            className="rounded-[5px] border-[#333] border-[1px] py-[5px] px-[24px] bg-[#333] text-white ml-[15px]"
          >
            {t("确定")}
          </Button>
        </div>
      </div>
    );
  };

  const MBDialog = ({ onClose, confirmText = "确定" }) => {
    console.log(typeof content, confirmText);
    return (
      <div
        className="rounded-[12px] z-50 absolute bg-white"
        style={{
          width: "90%",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}
      >
        <div className="text-center">
          <p className="text-[14px] text-[#666] py-[20px] pb-0">{_title}</p>
          <div className="text-[15px] py-[20px] border-b-[1px] pb-[30px]">
            {typeof content === "string" ? content : content({ onClose })}
          </div>
          <div className="flex">
            <Button
              onClick={() => onClose()}
              className="border-0 flex-1 py-[12px] text-[14px] border-r-[1px] text-[#999]"
            >
              {t("取消")}
            </Button>
            {confirmText !== null ? (
              <Button
                onClick={() => {
                  onOk(onClose);
                }}
                className="border-0 flex-1 py-[12px] text-[14px] text-[#FFC75A]"
              >
                {t(confirmText)}
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  const options = {
    title: "Title",
    message: "Message",
    childrenElement: () => <div />,
    customUI: (props) => {
      return isMdmax ? (
        <MBDialog confirmText={props.confirmText} onClose={props.onClose} />
      ) : (
        <PCDialog onClose={props.onClose} />
      );
    },
    closeOnEscape: false,
    closeOnClickOutside: false,
    keyCodeForClose: [8, 32],
    willUnmount: () => {},
    afterClose: () => {},
    onClickOutside: () => {},
    onKeypressEscape: () => {},
  };

  return confirmAlert(options);
}

function qrcode(props) {
  const {
    title,
    content,
    qrcode,
    qrcodeType = "url",
    renderElement,
    showFooter,
    onOk,
    onCancel,
    showClose,
  } = props;
  const isMdmax = mediaMatch.isMdmax;
  const is1Xl = mediaMatch.is1Xl;
  const t = getI18n().t; // 该函数没有返回render 无法使用hook，只能调用api
  const _title = title ? t(title) : t("提示");

  const PCDialog = ({ onClose }) => {
    return (
      <div
        className="rounded-[5px] z-50 fixed bg-white p-[30px] py-[20px] pb-[10px]"
        style={{
          width: 400,
          top: "12%",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        <div className="mb-[30px]">
          <div className="mb-[20px] flex items-center justify-between">
            {title}
            {showClose && (
              <i
                className="iconfont icon-close-circle-fill text-[26px] cursor-pointer"
                onClick={() => onClose()}
              ></i>
            )}
          </div>
          {qrcode && (
            <div className="flex justify-center items-center">
              {qrcodeType === "url" || !qrcodeType ? (
                <img
                  src={qrcode}
                  style={{ width: "180px", height: "180px" }}
                  alt=""
                />
              ) : (
                <QRCode value={qrcode} size={180} />
              )}
            </div>
          )}
          {content && (
            <div className="flex justify-center items-center">{content}</div>
          )}
          <div>{renderElement && renderElement()}</div>
        </div>
        {showFooter && (
          <div className="text-right">
            <Button
              onClick={() => onCancel(onClose)}
              className="rounded-[5px] border-[#ddd] border-[1px] py-[5px] px-[24px]"
            >
              {t("取消")}
            </Button>
            <Button
              onClick={() => {
                onOk(onClose);
              }}
              className="rounded-[5px] border-[#333] border-[1px] py-[5px] px-[24px] bg-[#333] text-white ml-[15px]"
            >
              {t("确定")}
            </Button>
          </div>
        )}
      </div>
    );
  };

  const MBDialog = ({ onClose, confirmText = "确定" }) => {
    return (
      <div
        className="rounded-[12px] z-50 absolute bg-white"
        style={{
          width: "80%",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}
      >
        <div className="mb-[30px] p-[30px] py-[20px] pb-[10px]">
          <p className="mb-[20px] text-[16px]">{title}</p>
          <QRCode
            value={qrcode}
            size={document.documentElement.offsetWidth * 0.65}
          />
          <div>{renderElement && renderElement()}</div>
          {content && (
            <div className="flex justify-center items-center">{content}</div>
          )}
        </div>
        {showFooter && (
          <div className="text-right">
            <Button
              onClick={() => onClose()}
              className="rounded-[5px] border-[#ddd] border-[1px] py-[5px] px-[24px]"
            >
              {t("取消")}
            </Button>
            <Button
              onClick={() => {
                onOk(onClose);
              }}
              className="rounded-[5px] border-[#333] border-[1px] py-[5px] px-[24px] bg-[#333] text-white ml-[15px]"
            >
              {t("确定")}
            </Button>
          </div>
        )}
      </div>
    );
  };

  const options = {
    title: "Title",
    message: "Message",
    childrenElement: () => <div />,
    customUI: (props) => {
      return isMdmax ? (
        <MBDialog confirmText={props.confirmText} onClose={props.onClose} />
      ) : (
        <PCDialog onClose={props.onClose} />
      );
    },
    closeOnEscape: false,
    closeOnClickOutside: false,
    keyCodeForClose: [8, 32],
    willUnmount: () => {},
    afterClose: () => {},
    onClickOutside: () => {},
    onKeypressEscape: () => {},
  };

  return confirmAlert(options);
}

Dialog.confirm = confirm;
Dialog.qrcode = qrcode;

function Dialog() {
  return {};
}

export default Dialog;
